var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyBtnOnHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 14,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6673 1.33341C10.6673 0.965225 10.3688 0.666748 10.0007 0.666748H2.66732C1.93398 0.666748 1.33398 1.26675 1.33398 2.00008V10.6667C1.33398 11.0349 1.63246 11.3334 2.00065 11.3334C2.36884 11.3334 2.66732 11.0349 2.66732 10.6667V2.00008H10.0007C10.3688 2.00008 10.6673 1.7016 10.6673 1.33341ZM12.6673 3.33341H5.33398C4.60065 3.33341 4.00065 3.93341 4.00065 4.66675V14.0001C4.00065 14.7334 4.60065 15.3334 5.33398 15.3334H12.6673C13.4007 15.3334 14.0007 14.7334 14.0007 14.0001V4.66675C14.0007 3.93341 13.4007 3.33341 12.6673 3.33341ZM5.33398 14.0001H12.6673V4.66675H5.33398V14.0001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#3537E5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBtnOnHover);
export default __webpack_public_path__ + "static/media/copy-btn-on-hover.0220ca6505687774301f19394eeb08f6.svg";
export { ForwardRef as ReactComponent };